export default function AuthLoadingScreen() {
  return (
    <div className="hc-page-shell flex min-h-screen items-center justify-center">
      <div className="size-6 animate-spin rounded-full border-2 border-hc-primary border-t-transparent" />
    </div>
  );
}
